import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "./AdminAuth";
import { Truck, ArrowRight, AlertCircle } from "lucide-react";

const AdminLogin = () => {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("admin@turbo2transit.com");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav(loc.state?.from?.pathname || "/admin", { replace: true });
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0b1210] text-white p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-xl bg-[var(--tt-green)] grid place-items-center">
            <Truck className="h-5 w-5" />
          </div>
          <div>
            <div className="font-display text-xl font-bold leading-tight">Turbo BD Console</div>
            <div className="text-xs text-white/50 uppercase tracking-widest mt-0.5">Internal · admin only</div>
          </div>
        </div>

        <form onSubmit={submit} className="rounded-2xl bg-[#0f1512] border border-white/10 p-6 md:p-8 space-y-4">
          <h1 className="font-display text-2xl font-bold">Sign in</h1>
          <label className="block">
            <span className="text-[11px] uppercase tracking-wider text-white/50">Email</span>
            <input
              data-testid="admin-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-xl bg-white/5 border border-white/10 px-3.5 py-3 text-sm outline-none focus:border-[var(--tt-green)] transition"
              autoFocus
              required
            />
          </label>
          <label className="block">
            <span className="text-[11px] uppercase tracking-wider text-white/50">Password</span>
            <input
              data-testid="admin-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-xl bg-white/5 border border-white/10 px-3.5 py-3 text-sm outline-none focus:border-[var(--tt-green)] transition"
              required
            />
          </label>
          {err && (
            <div className="flex items-start gap-2 rounded-lg bg-red-500/10 border border-red-500/20 text-red-300 text-xs p-3">
              <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" /> {err}
            </div>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--tt-green)] hover:bg-[var(--tt-green-dark)] px-4 py-3 font-semibold transition disabled:opacity-50"
          >
            {loading ? "Signing in…" : (<>Sign in <ArrowRight className="h-4 w-4" /></>)}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
